const priceData = [
  { product: "Straight Stairlift", range: "₹1,55,000 - ₹3,00,000", note: "Best for straight staircases. Quick install." },
  { product: "Curved Stairlift", range: "₹4,50,000 - ₹15,00,000", note: "Custom-made for turns, landings & spiral stairs." },
  { product: "Outdoor Stairlift", range: "₹2,00,000 - ₹7,00,000", note: "Weatherproof models for gardens & porches." },
  { product: "Wheelchair Platform Lift", range: "₹6,00,000 - ₹15,00,000", note: "For offices, hospitals, temples & commercial accessibility." },
];

export default function PriceTable() {
  return (
    <section data-testid="price-table-section" className="py-16 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b22300] mb-3 text-center">Transparent Pricing</p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-stone-900 text-center font-['Outfit']">
          Price Guide - Home & Commercial
        </h2>
        <p className="mt-3 text-stone-500 text-center">Final price varies by customization, floors & installation requirements</p>

        <div className="mt-8 overflow-x-auto rounded-2xl border border-stone-200">
          <table data-testid="price-table" className="w-full text-sm">
            <thead>
              <tr className="bg-stone-50 border-b border-stone-200">
                <th className="text-left px-5 py-4 font-semibold text-stone-900 font-['Outfit']">Stair Lift Type</th>
                <th className="text-left px-5 py-4 font-semibold text-stone-900 font-['Outfit']">Price Range (INR)</th>
                <th className="text-left px-5 py-4 font-semibold text-stone-900 font-['Outfit'] hidden sm:table-cell">Notes</th>
              </tr>
            </thead>
            <tbody>
              {priceData.map((row, i) => (
                <tr key={row.product} data-testid={`price-row-${i}`} className="border-b border-stone-100 last:border-0 hover:bg-stone-50/50 transition-colors">
                  <td className="px-5 py-4 font-medium text-stone-800">{row.product}</td>
                  <td className="px-5 py-4 text-[#b22300] font-semibold">{row.range}</td>
                  <td className="px-5 py-4 text-stone-500 hidden sm:table-cell">{row.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-center text-stone-400 text-xs">EMI options available. Contact us for a personalized quote.</p>
      </div>
    </section>
  );
}
